module.exports = __webpack_public_path__ + "img/Vector.c66533e6.svg";